import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";
import {
  type LinkToCustomerSsoCommand,
  type SignInResult,
  postAuthMigrateLinkToCustomerSso,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: SignInResult) => void;
  onError?: (error: unknown) => void;
};

/**
 * Links the currently authenticated non-migrated User to an existing Identity, proving ownership
 * with a Google/Apple sign-in whose e-mail is that Identity's login (instead of its password).
 */
export const useLinkToCustomerSsoMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (data: LinkToCustomerSsoCommand) =>
        postAuthMigrateLinkToCustomerSso(data),
    ),
    onSuccess: (result: SignInResult) => {
      queryClient.invalidateQueries({ queryKey: userInfoKeys.all });
      onSuccess?.(result);
    },
    onError,
  });
};
